<div fxLayout="column" class="custom-width">
  <div fxLayout="row">
    <div fxFlex="12"></div>
    <div class="dialog-title" mat-dialog-title fxFlex="76">ACTIVIDAD</div>
    <button
      mat-icon-button
      fxFlex="12"
      mat-dialog-close
      class="close-button"
      color="warn"
    >
      <mat-icon> close </mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form
      name="form"
      *ngIf="form"
      [formGroup]="form"
      (submit)="save()"
      autocomplete="off"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        color="accent"
      >
        <mat-label>Actividad {{ lblActivityNumber[actIndex] }}</mat-label>
        <input matInput formControlName="description" numbersOnly />
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.description"
          [ngClass]="{ 'error-icon': controlHasError('description') }"
        >
          class
        </mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        color="accent"
      >
        <mat-label>Etiqueta</mat-label>
        <input matInput formControlName="label" numbersOnly />
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.label"
          [ngClass]="{ 'error-icon': controlHasError('label') }"
        >
          class
        </mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        color="accent"
      >
        <mat-label>Tipo regimen</mat-label>
        <mat-select formControlName="regimeType">
          <mat-option [value]="1">General</mat-option>
          <mat-option [value]="2">Rimpe</mat-option>
        </mat-select>
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.regimeType"
          [ngClass]="{ 'error-icon': controlHasError('regimeType') }"
        >
          class
        </mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        color="accent"
      >
        <mat-label>Declaración</mat-label>
        <mat-select formControlName="declaration">
          <mat-option [value]="1">Mensual</mat-option>
          <mat-option [value]="2">Semestral</mat-option>
        </mat-select>
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.declaration"
          [ngClass]="{ 'error-icon': controlHasError('declaration') }"
        >
          class
        </mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        color="accent"
      >
        <mat-label>Importador</mat-label>
        <mat-select formControlName="importing">
          <mat-option [value]="true">Si</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.importing"
          [ngClass]="{ 'error-icon': controlHasError('importing') }"
        >
          class
        </mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        color="accent"
      >
        <mat-label>Exportador</mat-label>
        <mat-select formControlName="export">
          <mat-option [value]="true">Si</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
        <mat-icon
          matSuffix
          class="secondary-text"
          [matTooltip]="notification.export"
          [ngClass]="{ 'error-icon': controlHasError('export') }"
        >
          class
        </mat-icon>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row">
    <button
      mat-raised-button
      color="accent"
      class="submit-button w-button"
      (click)="save()"
      [disabled]="form.invalid || isLoading"
      color="accent"
    >
      <div *ngIf="isLoading" class="loadingComponent">
        <app-loading [isLoading]="isLoading" />
      </div>

      <span *ngIf="!isLoading">{{ txtBtn }}</span>
    </button>
  </mat-dialog-actions>
</div>
